/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 4/1/2022.
 */

import React from 'react'
import {withRouter} from 'react-router'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import {injectIntl} from 'react-intl';
import * as FleetActions from './FleetActions'
import {Button, Grid} from "@scuf/common";
import Loader from '../common/Loader'
import BreadCrumb from "../common/Bradcrumb";
import {getBreadcrumbItemsFleet} from "../utils/Helpers";
import ExpandableCard from "../common/ExpandableCard";
import FleetCard from "./FleetCard"
import AssetCard from "./AssetCard"
import Filter from "./Filter";
import {FLEETS_SORT} from "./FleetsConst";
import FleetChart from "../common/FleetChart";
import ErrorTitle from "../common/ErrorTitle";
import {userHasActivity} from "../security/SecurityUtils";
import {ACTIVITY_TYPES} from "../security/SecurityConst";
import {Routes} from "../utils/Routes";

class Fleet extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            filter: {
                search: '',
                sort: FLEETS_SORT.NAME,
            },
        }

        this.searchChanged = this.searchChanged.bind(this)
        this.sortChanged = this.sortChanged.bind(this)
    }

    componentDidMount() {
        this.fetchFleet(this.props.match.params.fleetId)
    }

    componentWillUnmount() {
        this.props.FleetActions.clearState()
    }

    componentDidUpdate(prevProps){
        if(prevProps.match.params.fleetId !== this.props.match.params.fleetId) {
            this.cleanFilter(() => this.fetchFleet(this.props.match.params.fleetId))
        }
    }

    fetchFleet(fleetId) {
        return this.props.FleetActions.fetchFleet(fleetId).then(() => {
            if (this.props.fleet.details) {
                this.fetchCards()
            }
        })
    }

    fetchCards() {
        if (this.props.fleet.details.subfleetCount > 0) {
            this.fetchSubfleets()
        } else {
            this.fetchAssets()
        }
    }

    fetchSubfleets() {
        return this.props.FleetActions.fetchSubFleets(this.props.fleet.details.id, this.state.filter.search, this.state.filter.sort)
    }

    fetchAssets() {
        return this.props.FleetActions.fetchAssets(this.props.fleet.details.id, this.state.filter.search, this.state.filter.sort)
    }

    getAttributesComponents(fleet) {
        const column1Attrs = []
        const column2Attrs = []

        if (fleet.subfleetCount > 0) {
            column1Attrs.push(this.getAttributeRow(fleet, 'subfleetCount'))
        }
        column1Attrs.push(this.getAttributeRow(fleet, 'assetCount'))
        column2Attrs.push(this.getAttributeRow(fleet, 'faultsCount'))

        return <ExpandableCard
            expandable={false}
            content={<Grid><Grid.Row><Grid.Column width={6}>{column1Attrs}</Grid.Column><Grid.Column
                width={6}>{column2Attrs}</Grid.Column></Grid.Row></Grid>}
            interactive={false}
            className='attributes-card'
        />
    }

    getAttributeRow(fleet, key) {
        const {intl} = this.props
        const name = intl.formatMessage({id: 'fleet.attr.' + key})
        return <Grid.Row key={key}><Grid.Column width={5}>{name}:</Grid.Column><Grid.Column width={7} className="attr-value">{fleet[key]}</Grid.Column></Grid.Row>
    }

    getFleetCards() {
        return this.props.fleet.subfleets.map(f =>
            <Grid.Column width={3} sWidth={12} mWidth={4} key={f.id}><FleetCard fleet={f} /></Grid.Column>)
    }

    getAssetCards() {
        return this.props.fleet.assets.map(a =>
            <Grid.Column width={3} sWidth={12} mWidth={4} key={a.id}><AssetCard asset={a} /></Grid.Column>)
    }

    searchChanged(search) {
        this.setState({
            ...this.state,
            filter: {
                ...this.state.filter,
                search: search,
            },
        }, this.fetchCards)
    }

    sortChanged(sort) {
        this.setState({
            ...this.state,
            filter: {
                ...this.state.filter,
                sort: sort,
            },
        }, this.fetchCards)
    }

    cleanFilter(callback) {
        return this.setState({
            ...this.state,
            filter: {
                ...this.state.filter,
                search: '',
            },
        }, callback)
    }

    getEditButton() {
        const {intl, history, fleet} = this.props
        if (userHasActivity(this.props.userProfile, ACTIVITY_TYPES.FLEETS_WRITE)) {
            return <Button content={intl.formatMessage({id: 'link.edit.fleet'})} type="secondary"
                           onClick={() => history.push(Routes.FLEETS_ADMIN + "/" + fleet.details.id)}/>
        }
        return null
    }

    render() {
        const {fleet} = this.props

        if (fleet.error) {
            return <ErrorTitle title={"fleet.detail.error."+fleet.error} />
        }

        if (!fleet.details) {
            return null
        }

        let breadcrumbComponent = null
        if (fleet.details) {
            breadcrumbComponent = <BreadCrumb items={getBreadcrumbItemsFleet(fleet.details.path)}/>
        }

        const fleetInfo = this.getAttributesComponents(fleet.details)
        const fleetCards = fleet.details.subfleetCount > 0 ? this.getFleetCards() : this.getAssetCards()

        return (
            <div id="fleet-detail">
                {breadcrumbComponent}
                <Loader loading={this.props.fleet.loading}/>
                <Grid className="fleet-header">
                    <Grid.Row>
                        <Grid.Column width={4} xsWidth={12}>
                            <h2>{fleet.details.name}</h2>
                            <div className="chart">
                                <FleetChart fleet={this.props.fleet.details} height={220} />
                            </div>
                        </Grid.Column>
                        <Grid.Column width={6} xsWidth={12}>
                            {fleetInfo}
                        </Grid.Column>
                        <Grid.Column width={2} sWidth={12}>
                            <div className="right">
                                {this.getEditButton()}
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>

                <Loader loading={this.props.fleet.subResourceLoading}/>
                <Filter search={this.state.filter.search} searchChanged={this.searchChanged} className="fleets-filter"
                        sort={this.state.filter.sort} sortOptions={FLEETS_SORT} sortChanged={this.sortChanged}/>
                <Grid className="fleets-grid">
                    <Grid.Row>
                        {fleetCards}
                    </Grid.Row>
                </Grid>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        fleet: state.fleet,
        userProfile: state.security.userProfile,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        FleetActions: bindActionCreators(FleetActions, dispatch),
    }
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(Fleet)))